export default __webpack_public_path__ + "static/media/436.5d6d659d.jpg";